
type Theme = 'light' | 'dark';

class ThemeManager {
  currentTheme: Theme;
  currentColour: string;

  constructor() {
    const savedTheme = localStorage.getItem('theme') as Theme | null;
    const savedColour = localStorage.getItem('colour') as string | null;
    this.currentTheme = savedTheme === 'light' || savedTheme === 'dark' ? savedTheme : 'dark';
    document.documentElement.setAttribute('data-bs-theme', this.currentTheme);

    if (savedColour == null) {
      this.currentColour = '#21252A';
    } else {
      this.currentColour = savedColour;
    }
  }

  public getCurrentTheme(): Theme {
    return this.currentTheme;
  }

  public getCurrentColour(): string {
    return this.currentColour;
  }

  public setTheme(theme: Theme): void {
    this.currentTheme = theme;
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-bs-theme', this.currentTheme);
    this.setColour(theme === 'light' ? '#FFFFFF' : '#21252A');
  }

  public setColour(colour: string): void {
    this.currentColour = colour;
    localStorage.setItem('colour', colour);
  }

  public toggleTheme(): void {
    if (this.currentTheme === 'light') {
      this.setTheme('dark');
    } else {
      this.setTheme('light');
    }
  }
}

const themeManager = new ThemeManager();
export default themeManager;
